var path = 'areas/projects/actions/azure_web_app/Octopus.AzureWebApp_summary.html';
var html = "<p> Deploy an Azure Web App <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=FeedName>{{ FeedName }}</strong><em ng-hide=FeedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_web_app/Octopus.AzureWebApp_summary.html
// module id = 8567842067470662
// module chunks = 1